<div id="fileselector" *ngIf="fsc.visible | async">
  <div id="fileselector_content" class="container">
    <wol-header></wol-header>
    <div class="row" style="width:100%; height:100%; margin:0px; position:relative;">
      <wol-filebrowser style="width:100%; height:100%; padding:10px;"></wol-filebrowser>
    </div>
    <wol-footer></wol-footer>
  </div>
</div>
